import React from 'react';

import TimelineBlock from './TimelineBlock';

const Timeline = ({translate, items}) => (
	<div className="cd-container cd-timeline">
		{
			items.map((item, index) => (
				<TimelineBlock key={index} translate={translate} {...item} odd={(index + 1) % 2 === 0}/>
			))
		}
	</div>
);

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/elements/Resume/Timeline.js